import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBnqAHQfnuIxtuTO3jzJHsgWKLXnnGL9ZI",
  // The Google sign-in popup opens on this domain and Google's consent screen names it, so it's ours, not
  // calendar-mvp-2b377.firebaseapp.com. Needs https://app.frisoapp.com/__/auth/handler as an authorized
  // redirect URI on the OAuth client (Google Cloud → Credentials).
  authDomain: "app.frisoapp.com",
  projectId: "calendar-mvp-2b377",
  storageBucket: "calendar-mvp-2b377.firebasestorage.app",
  messagingSenderId: "27530491678",
  appId: "1:27530491678:web:5f91cfa351daf622a4fb0f"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export default app;